import { CombatCalculator } from "@/core/battle/CombatCalculator";
import { PathCalculator } from "@/core/battle/PathCalculator";
import { BattleUnit, Hex } from "@/core/types/battle.types";
import { coordsToId, getHexDistance } from "@/core/utils/hex.utils";

export class ProtectionMapCalculator {
    /**
     * Генерує актуальну мапу захисту на момент виклику.
     * Має викликатися перед кожним плануванням ходу AI.
     */
    public static calculate(
        unit: BattleUnit,
        enemies: BattleUnit[],
        allies: BattleUnit[],
        battleMap: Map<string, Hex>
    ): Map<string, number> {
        const protectionMap = new Map<string, number>();

        for (const enemy of enemies) {
            if (enemy.isDead) continue;
            const baseSkill = enemy.skills[0];
            const enemyRange = baseSkill?.range || 1;
            
            const engagingAllies = allies.filter(a => 
                !a.isDead && getHexDistance({ q: a.q, r: a.r }, { q: enemy.q, r: enemy.r }) <= enemyRange
            );

            const alliesCount = engagingAllies.length;
            if (alliesCount === 0) continue;

            // 2. Базова оцінка небезпеки ворога (на основі його скіла)
            
            const enemyAvgDmg = CombatCalculator.calculateRawDamage(
                enemy,
                unit, 
                baseSkill?.powerMult || 1.0,
                enemy.stats.armorPenetration + (baseSkill?.armorPenBonus || 0),
                true
            );

            // 3. Розрахунок сили пригнічення (Mitigation Value)
            // Використовуємо середню броню тих, хто оточив ворога
            // const avgArmor = engagingAllies.reduce((sum, a) => sum + a.stats.armor, 0) / alliesCount;
            // const qualityMult = avgArmor > 50 ? 1.2 : 0.8;

            // Формула: Шкода * (Базовий тиск 30% + 10% за кожного додаткового союзника) * множник якості
            // let mitigationValue = enemyAvgDmg * (0.3 + (alliesCount - 1) * 0.1) * qualityMult;
            let mitigationValue = enemyAvgDmg * (0.3 + (alliesCount - 1) * 0.1);
            
            // Ліміт: не більше 75% шкоди ворога може бути "розмито"
            mitigationValue = Math.min(mitigationValue, enemyAvgDmg * 0.75);

            // 4. Позначаємо всі гекси в радіусі атаки ворога як "частково безпечні"
            
            const affectedHexes = PathCalculator.getRadius(
                { q: enemy.q, r: enemy.r },
                enemyRange,
                battleMap,
                false,
                true
            );

            affectedHexes.forEach((dist, hexId) => {
                const currentVal = protectionMap.get(hexId) || 0;
                // Бонуси підсумовуються, якщо на гекс впливає кілька "пригнічених" ворогів
                protectionMap.set(hexId, currentVal + mitigationValue);
            });
        }

        return protectionMap;
    }
}